module.exports = new __parcel__URL__("alerts-task-two-illustration-dark.37c696ca.png").toString();